import { z } from 'zod';

const PAID_BY_OPTIONS = z.enum(['MERCHANT', 'SHOPPER'], {
  required_error: 'Please select who will pay for shipping.'
});

const FEE_TYPE_OPTIONS = z.enum(['FLAT_FEE', 'CARRIER_FEE'], {
  required_error: 'Please select a shipping fee type.'
});

export const FORM_SCHEMA = z
  .object({
    paidBy: PAID_BY_OPTIONS,
    feeType: FEE_TYPE_OPTIONS,
    feeAmount: z.coerce.number().min(0, 'Fee amount must be at least 0.')
  })
  .refine(
    data => {
      if (data.paidBy === 'SHOPPER' && data.feeType === 'FLAT_FEE') {
        return data.feeAmount > 0;
      }
      return true;
    },
    { message: 'Fee amount must greater than 0.', path: ['feeAmount'] }
  );

export const PAYER = PAID_BY_OPTIONS.Values;

export const FEE_TYPE = FEE_TYPE_OPTIONS.Values;

/** @type {z.infer<typeof FORM_SCHEMA>} */
export const DEFAULT_FORM_DATA = {
  paidBy: PAYER.MERCHANT,
  feeType: FEE_TYPE.FLAT_FEE,
  feeAmount: 0
};

export const FEE_TYPE_VALUE = Object.freeze({
  [FEE_TYPE.FLAT_FEE]: 'flat_fee',
  [FEE_TYPE.CARRIER_FEE]: 'direct'
});
